import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import {
  UseCommercialConsultationsQueryParams,
  UseCommercialConsultationsResponse,
} from './useCommercialInProgressConsultations.types';

const PREFIX = '[commercialInProgressConsultationsQuery]';

export const commercialInProgressConsultationsQuery = async (
  params: UseCommercialConsultationsQueryParams
) => {
  console.log(PREFIX, `Fetching commercial in progress consultations...`);
  const response = await CONSULTATIONS_ENDPOINTS.allCommercialInProgressConsultations(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commercial in progress consultations.`);
  return json as UseCommercialConsultationsResponse;
};
